import { Component, OnInit, Input } from '@angular/core';
import { BookResult } from 'src/app/models/api_models/book';
import { Router } from '@angular/router';

@Component({
  selector: 'app-last-station',
  templateUrl: './last-station.component.html',
  styleUrls: ['./last-station.component.scss']
})
export class LastStationComponent implements OnInit {

  private _bookList : BookResult[] = null;

  public get bookList() : BookResult[] {
    return this._bookList;
  }

  @Input() 
  public set bookList(bookList : BookResult[]){
    this._bookList = bookList;
  }

  constructor(private router: Router) { }

  ngOnInit() {
  }

  goToDetail(id : number) {
    this.router.navigateByUrl("/auth/reservation/" + id);
  }

}
